import { render, staticRenderFns } from "./Paginition.vue?vue&type=template&id=7475225e&scoped=true&"
import script from "./Paginition.vue?vue&type=script&lang=ts&"
export * from "./Paginition.vue?vue&type=script&lang=ts&"
import style0 from "./Paginition.vue?vue&type=style&index=0&id=7475225e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7475225e",
  null
  
)

export default component.exports